import styled from 'styled-components';
import {Row} from 'antd';

const ErrorRow = styled(Row)`
  color: #f44336;
`;

export default ErrorRow;
